import { render, staticRenderFns } from "./MoveItemTo.vue?vue&type=template&id=670f701c&scoped=true"
import script from "./MoveItemTo.vue?vue&type=script&lang=js"
export * from "./MoveItemTo.vue?vue&type=script&lang=js"
import style0 from "./MoveItemTo.vue?vue&type=style&index=0&id=670f701c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f701c",
  null
  
)

export default component.exports